<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingCampaignList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-expansion-panels v-model="currentPanel">
            <v-expansion-panel
                v-for="(campaignItems, infoProvider, index) in campaigns"
                :key="infoProvider"
                :style="{
                    background: currentPanel === index ? '#E6E6E6' : '#FFFFFF'
                }"
            >
                <v-expansion-panel-header>
                    <div
                        :style="{
                            'text-decoration': currentPanel === index ? 'underline' : 'none',
                            'font-weight': 'bold'
                        }"
                    >
                        {{ t(capitalizeFirstLetter(infoProvider)) }}
                    </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content
                    :style="{
                        background: currentPanel === index ? '#E6E6E6' : '#FFFFFF'
                    }"
                >
                    <v-data-table
                        :items-per-page="50"
                        :footer-props="footerProps"
                        :search="searchCampaignString"
                        class="campaigns-table"
                        dense
                        :headers="tableHeaders"
                        :items="campaignItems"
                        group-by="related_name_group"
                        group-key="related_name_group"
                        group-desc
                        item-key="id"
                    >
                        <template v-slot:group.header="{ group, headers, toggle, isOpen, item }">
                            <td :colspan="headers.length" class="pl-1 font-weight-bold">
                                <v-btn :ref="group" :data-open="isOpen" icon small @click="toggle">
                                    <v-icon v-if="isOpen">arrow_drop_down</v-icon>
                                    <v-icon v-else>arrow_drop_up</v-icon>
                                </v-btn>
                                {{ group }}
                            </td>
                        </template>

                        <template v-slot:item="{ item }">
                            <tr
                                :key="'campaign_' + item.id"
                                @click="handleTableRowClick(item)"
                                :class="{
                                    activeTableRow: activeCampaign && parseInt(item.id) === parseInt(activeCampaign.id)
                                }"
                            >
                                <td>{{ item.name ? item.name : "-" }}</td>
                                <td>{{ item.description ? item.description : "-" }}</td>
                                <td>{{ item.start_date ? item.start_date : "-" }}</td>
                                <td>{{ item.end_date ? item.end_date : "-" }}</td>
                                <td>{{ item.related_export_client_name || "-" }}</td>
                                <td>{{ item.related_client_name || "-" }}</td>
                                <td>{{ item.related_store_name || "-" }}</td>
                                <td>{{ item.related_tag_name || "-" }}</td>
                                <td style="text-align: right" v-if="false">
                                    {{
                                        item.amount !== null
                                            ? item.amount % 1 !== 0
                                                ? item.amount.toFixed(2)
                                                : item.amount.toFixed(0)
                                            : "-"
                                    }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { helperMixin } from "@/mixins/helper-mixin";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "campaign-list",
    data() {
        return {
            currentPanel: 0,
            footerProps: { "items-per-page-options": [25, 50, 100] },
            tableHeaders: [
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Description"),
                    align: "left",
                    value: "description"
                },
                {
                    text: this.t("Start date"),
                    align: "left",
                    value: "start_date"
                },
                {
                    text: this.t("End date"),
                    align: "left",
                    value: "end_date"
                },
                {
                    text: this.t("Export client"),
                    align: "left",
                    value: "related_export_client_name"
                },
                {
                    text: this.t("Client"),
                    align: "left",
                    value: "related_client_name"
                },
                {
                    text: this.t("Store"),
                    align: "left",
                    value: "related_store_name"
                },
                {
                    text: this.t("Tag"),
                    align: "left",
                    value: "related_tag_name"
                }
                // {
                //     text: this.t("Amount"),
                //     align: "right",
                //     value: "amount"
                // },
            ]
        };
    },
    async mounted() {
        await this.getCampaignList();
    },
    mixins: [helperMixin],
    computed: {
        ...mapState("CampaignStore", ["campaigns", "loadingCampaignList", "activeCampaign", "searchCampaignString"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapActions("CampaignStore", ["getCampaignData", "getCampaignList"]),
        handleTableRowClick(campaign) {
            if (!this.hasPermissionForAction(PermissionsConstants.CAMPAIGN, PermissionsConstants.VIEW)) {
                return;
            }
            if (this.$route.name !== "campaign-view") {
                this.$router.push({ name: "campaign-view", params: { campaignId: campaign.id } });

                return;
            }
            if (
                this.$route.name === "campaign-view" &&
                parseInt(campaign.id) !== parseInt(this.$route.params.campaignId)
            ) {
                this.$router.push({ name: "campaign-view", params: { campaignId: campaign.id } });
                this.getCampaignData(campaign.id);
            }
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.v-data-table-header {
    background-color: #f0f0f0;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
td {
    height: 25px !important;
}
</style>
